import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { HttpClientModule ,HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { Daterangepicker } from 'ng2-daterangepicker';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';  
import { MultiTranslateHttpLoader } from "ngx-translate-multi-http-loader";
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
 
import {MatNativeDateModule} from "@angular/material/core";
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatStepperModule} from '@angular/material/stepper';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import { ModalModule } from 'ngx-bootstrap/modal';
import {MatIconModule} from '@angular/material/icon';
import{FunctionService} from './shard/function.service';
import {BaseService} from './base.service';

 export function HttpLoaderFactory(http: HttpClient) {  
  return new MultiTranslateHttpLoader(http, [  
    { prefix: "./assets/translate/menu/", suffix: ".json" },  
  ]);  
}

@NgModule({
  declarations: [AppComponent, HeaderComponent, FooterComponent       ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
   
    SlickCarouselModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    FormsModule,
    TranslateModule.forRoot({  
      loader: {  
        provide: TranslateLoader,  
        useFactory: HttpLoaderFactory,  
        deps: [HttpClient]  
      }  
    }) ,
    NgbModule,
    Daterangepicker,
    NoopAnimationsModule,
    MatProgressBarModule,
    MatStepperModule,
    MatCheckboxModule,
    MatCardModule,
    ModalModule.forRoot(),
    MatButtonModule,
    MatIconModule,
    MatNativeDateModule,
  ],
  providers: [BaseService ,FunctionService ],
  bootstrap: [AppComponent],
})

export class AppModule {}
//  "node_modules/flag-icon-css/css/flag-icon.min.css",
